import React, { useEffect } from 'react';
import PaymentScheduleStyle from './styles';
import { Form, Input, Button, Space, Flex } from 'antd';
import { MinusCircleOutlined, PlusOutlined } from '@ant-design/icons';
import { useDispatch, useSelector } from 'react-redux';
import { quoteDetailSelector } from 'src/redux/selectors/quoteDetailSelector';
import { toggleEditQuoteSelector } from 'src/redux/selectors/toggleEditQuoteSelector';
import { updateParamsQuoteDetail } from 'src/redux/actions/paramsQuoteDetailAction';
import { paramsQuoteDetailSelector } from 'src/redux/selectors/paramsQuoteDetailSelector';

const PaymentSchedule: React.FC = () => {
    const [form] = Form.useForm();

    const dispatch = useDispatch();
    const { paymentSchedule } = useSelector(quoteDetailSelector);
    const isEdit = useSelector(toggleEditQuoteSelector);
    const params = useSelector(paramsQuoteDetailSelector);

    const paymentScheduleValue = Form.useWatch('paymentSchedule', form);

    useEffect(() => {
        form.setFieldsValue({
            paymentSchedule: params?.paymentSchedule ??
                paymentSchedule ?? [{ key: '', value: '' }],
        });
        form.validateFields();
    }, [paymentSchedule, form, params?.paymentSchedule]);

    useEffect(() => {
        if (
            paymentScheduleValue &&
            JSON.stringify(paymentSchedule) !==
                JSON.stringify(paymentScheduleValue)
        ) {
            dispatch(
                updateParamsQuoteDetail({
                    paymentSchedule: paymentScheduleValue,
                }),
            );
        }
    }, [paymentScheduleValue, dispatch, paymentSchedule]);

    const renderContent = () => {
        if (isEdit) {
            return (
                <Form form={form} layout="vertical">
                    <Form.List name="paymentSchedule">
                        {(fields, { add, remove }) => (
                            <>
                                {fields.map(({ key, name, ...restField }) => (
                                    <Space
                                        key={key}
                                        style={{
                                            display: 'flex',
                                        }}
                                        align="start"
                                    >
                                        <Form.Item
                                            {...restField}
                                            name={[name, 'key']}
                                            label={null}
                                            rules={[
                                                {
                                                    required: true,
                                                    message: '',
                                                },
                                            ]}
                                        >
                                            <Input placeholder="Enter Amount" />
                                        </Form.Item>

                                        <Form.Item
                                            {...restField}
                                            name={[name, 'value']}
                                            label={null}
                                            rules={[
                                                {
                                                    required: true,
                                                    message: '',
                                                },
                                            ]}
                                        >
                                            <Input placeholder="Enter Date" />
                                        </Form.Item>

                                        {fields.length > 1 && (
                                            <MinusCircleOutlined
                                                style={{ marginTop: 8 }}
                                                onClick={() => remove(name)}
                                            />
                                        )}
                                    </Space>
                                ))}

                                <Form.Item>
                                    <Button
                                        type="dashed"
                                        onClick={() => add()}
                                        block
                                        icon={<PlusOutlined />}
                                        className="btn-add"
                                    >
                                        Add
                                    </Button>
                                </Form.Item>
                            </>
                        )}
                    </Form.List>
                </Form>
            );
        }
        return (
            <div className="box-values">
                {paymentSchedule?.map((item: any, index: number) => (
                    <Flex
                        key={index}
                        className={
                            index + 1 === paymentSchedule.length ? 'bold' : ''
                        }
                        justify="space-between"
                        gap={8}
                    >
                        <div>{item?.key}</div>
                        <div className="text-right">{item?.value}</div>
                    </Flex>
                ))}
            </div>
        );
    };

    return (
        <PaymentScheduleStyle className="card">
            <div className="header">Your Payment Schedule</div>
            {renderContent()}
        </PaymentScheduleStyle>
    );
};

export default PaymentSchedule;
